export type DateRange = {
    from: Date;
    to: Date;
};

export const isDateInRange = (date: Date, range: DateRange): boolean => {
    return date.getTime() >= range.from.getTime() && date.getTime() < range.to.getTime();
};

export const rangeFullyContainsRange = (range: DateRange, compare: DateRange) => {
    return (
        range.from.getTime() <= compare.from.getTime() && range.to.getTime() >= compare.to.getTime()
    );
};
